import { createFileRoute } from '@tanstack/react-router';
import CreateLogTemplate from '../../../features/baseData/logTemplates/logTemplate/create';
import {
  createPermissionGuard,
  getPermissionSet,
  LOG_TEMPLATES_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/verfuegungsvorlagen/neu')({
  component: CreateLogTemplate,
  beforeLoad: createPermissionGuard(
    getPermissionSet(LOG_TEMPLATES_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateLogTemplateRoute = Route;
